'use client';
var styles = {"article":"FixedLayer-module_article__Jw-LG","hide":"FixedLayer-module_hide__H-OVM","top":"FixedLayer-module_top__c2W-X","bottom":"FixedLayer-module_bottom__mio-5"};

export { styles as default };
